import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { Button } from '../prime'
import { Alert } from '../../components';
import UserData from '../../services/userdata';

interface IProps { 
  storage?: IDataStorage;
  getEntity: () => any;
}

interface IState { 
  storage?: IDataStorage;
}

class Index extends React.Component<IProps, IState> {
  
  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    return res;
  }

  render() {
    return (
      <Button 
        icon="pi pi-download" 
        className="p-button-rounded p-button-help p-button-outlined" 
        tooltip="Guardar datos en el caché para utilizar mas tarde" 
        tooltipOptions={{ position: 'top' }} 
        style={{ marginLeft: 10 }} 
        onClick={() => {
          if (this.props.getEntity) {
            UserData.set(`form//${window.location.pathname}`, this.props.getEntity());
            Alert.info("Caché de datos", "Se guardó la información")
          }
        }}

      />
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
